import type { IconData } from '@stacksjs/iconify-core'

export const scissorsFlat: IconData = {
  "body": "<path fill=\"#8fbffa\" fill-rule=\"evenodd\" d=\"M21.5 13c0 1.816-.51 3.514-1.394 4.956c1.42-.82 3.288-1.866 5.316-2.913c2.182-1.126 4.556-2.257 6.758-3.107c2.186-.844 4.26-1.436 5.82-1.436c4.546 0 6.856 2.662 7.791 4.162c.504.807.024 1.74-.78 2.002C42.145 17.6 33.59 20.47 25.27 24c8.32 3.53 16.875 6.4 19.741 7.336c.804.263 1.284 1.195.78 2.002c-.935 1.5-3.245 4.162-7.791 4.162c-1.56 0-3.634-.592-5.82-1.436c-2.202-.85-4.576-1.981-6.758-3.107a130 130 0 0 1-5.316-2.913A9.5 9.5 0 1 1 6.44 27.297c1.094-.892 2.8-2.037 4.85-3.297c-2.05-1.26-3.756-2.405-4.85-3.296A9.5 9.5 0 1 1 21.5 13m-12 0a2.5 2.5 0 1 1 5 0a2.5 2.5 0 0 1-5 0m0 22a2.5 2.5 0 1 1 5 0a2.5 2.5 0 0 1-5 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default scissorsFlat
